import React, { useContext, useEffect, useState } from 'react'
import { View, StyleSheet, Dimensions, ScrollView, TouchableOpacity, Linking } from 'react-native'
import { Text, useTheme } from '@ui-kitten/components'
import { UserContext } from '../../global/UserProvider'
import { useTranslation } from 'react-i18next'
import { useAtomValue } from 'jotai'
import { organizationAtom } from '../../global/AtomsProvider'

export default function StatsListScreen({ navigation, style }) {
  const theme = useTheme()
  const { t } = useTranslation()
  const [context, setContext] = useContext(UserContext)
  const organization = useAtomValue(organizationAtom)

  const menuItems = [
    {
      title: t('stats.salesStats'),
      subtitle: t('stats.salesStatsDescription'),
      onPress: () => navigation.navigate('SalesStats'),
      roles: ['admin'],
      module: 'sales'
    },
    {
      title: t('stats.profitStats'),
      subtitle: t('stats.profitStatsDescription'),
      onPress: () => navigation.navigate('ProfitStats'),
      roles: ['admin']
    },
    {
      title: t('stats.paymentStats'),
      subtitle: t('stats.paymentStatsDescription'),
      onPress: () => navigation.navigate('PaymentStats'),
      roles: ['manager', 'admin'],
      module: 'payments'
    },
    {
      title: t('stats.shiftStats'),
      subtitle: t('stats.shiftStatsDescription'),
      onPress: () => navigation.navigate({name: 'ShiftsStats'}),
      roles: ['manager', 'admin'],
      module: 'shift'
    },
    {
      title: t('stats.productStats'),
      subtitle: t('stats.productStatsDescription'),
      onPress: () => navigation.navigate('ProductStats', {initialColumns: {
        saleAmount: true,
        profit: true,
      }}),
      roles: ['manager', 'admin']
    },
    {
      title: t('stats.writeOffStats'),
      subtitle: t('stats.writeOffStatsDescription'),
      onPress: () => navigation.navigate('ProductStats', {initialColumns: {
        writeOffAmount: true,
        writeOffQuantity: true,
      }}),
      roles: ['manager', 'admin'],
      module: 'writeOffs'
    },
    {
      title: t('stats.revisionStats'),
      subtitle: t('stats.revisionStatsDescription'),
      onPress: () => navigation.navigate('RevisionStats'),
      roles: ['manager', 'admin'],
      module: 'revisions'
    },
  ]

  return (
    <View style={style}>
      <Text category='label' style={{marginTop: 10, marginBottom: 5}}>{t('stats.allStats')}</Text>
        {
          menuItems.map((item, index) => (
            (item.roles == null || item.roles.includes(context.user.role)) && 
            (item.module == null || organization?.moduleEnabled?.[item.module]) &&
            (
              <TouchableOpacity
                style={[styles.item, {backgroundColor: theme['background-basic-color-1']}]}
                onPress={item.onPress}
                key={index.toString()}
              >
                <Text
                  style={styles.itemTitle}
                  category='s1'>
                  {item.title}
                </Text>
                <Text
                  style={styles.itemSubtitle}
                >
                  {item.subtitle}
                </Text>
              </TouchableOpacity>
            )
          ))
        }
    </View>
  );
}

const styles = StyleSheet.create({
  item: {
    borderRadius: 10,
    padding: 10,
    marginVertical: 5
  }, 

});
